/**
 * @fileoverview A function for validating a given GBP group ID.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import Uri from 'goog:goog.Uri';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {ValidateGoogleGroupResponse} from '/src/com/yext/listingslaunchstorm/js/data/validategooglegroupresponse';

/**
 * @param {number} linkedAccountId
 * @param {string | undefined} groupId
 * @param {string} testCase
 * @param {AbortSignal} abortSignal
 * @return {!Promise<ValidateGoogleGroupResponse>}
 */
export function validateGoogleGroup(linkedAccountId, groupId, testCase, abortSignal) {
  const businessId = window['businessId'];

  const query = new Uri.QueryData;
  query.set('externalAccountId', linkedAccountId);
  query.set('gbpGroupId', groupId);
  query.set('businessId', businessId);

  const uri = new Uri(Routes.validateGoogleGroup()).setQueryData(query);

  return doRequest('validateGoogleGroup', abortSignal, uri, 'GET')
    .then(jsonResponse => ValidateGoogleGroupResponse.fromJSON(jsonResponse));
}
